import { Controller } from '@hotwired/stimulus'
import { removeClass } from 'utils/toggle_class'
import { hideElement, showElement } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static targets = ['section', 'questionPanel', 'reportPanel', 'quizSidebar']
  static currentPanel

  // Shows questionPanel after an htmx settle event.
  initialize() {
    this.sectionTarget.addEventListener("htmx:afterSettle", (_event) => {
      this.showQuestion(_event)
    })

    // Create a named function so we can remove it later
    this.handleInitialHtmxLoad = () => {
      this.clickQuestionFromURLParams()
      // Remove the listener after first execution to prevent infinite loop
      document.body.removeEventListener("htmx:load", this.handleInitialHtmxLoad)
    }

    // This is needed to ensure that the question is clicked after the htmx:load event is triggered.
    document.body.addEventListener("htmx:load", this.handleInitialHtmxLoad)
  }

  clickQuestionFromURLParams() {
    const questionParam = new URLSearchParams(window.location.search).get("q")
    const questionIndex = parseInt(questionParam) - 1

    if (questionParam && this.hasQuizSidebarTarget) {
      const questionButtons = Array.from(this.quizSidebarTarget.querySelectorAll("li button"))

      if (questionButtons[questionIndex]) {
        questionButtons[questionIndex].dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }))
      }
    }
  }

  showQuestion(_event) {
    hideElement(this.reportPanelTarget)
    showElement(this.questionPanelTarget)
  }

  goBackToReport(_event) {
    hideElement(this.questionPanelTarget)
    showElement(this.reportPanelTarget)

    // Reset button state
    removeClass(
      this.quizSidebarTarget.querySelector(".c-quiz-question-button.-active"),
      "-active"
    )
  }
}
